import lb1 from "../assets/images/property/our service/lowRiseBuilding/lb-1.png";
import lb2 from "../assets/images/property/our service/lowRiseBuilding/lb-2.jpg";
import lb3 from "../assets/images/property/our service/lowRiseBuilding/lb-3.png";
import lb4 from "../assets/images/property/our service/lowRiseBuilding/lb-4.png";

import hb1 from "../assets/images/property/our service/highRise/hb1.png";
import hb2 from "../assets/images/property/our service/highRise/hb2.png";
import hb3 from "../assets/images/property/our service/highRise/hb3.png";
import hb4 from "../assets/images/property/our service/highRise/hb4.png";
import hb5 from "../assets/images/property/our service/highRise/hb5.png";
import hb6 from "../assets/images/property/our service/highRise/hb6.png";
import hb7 from "../assets/images/property/our service/highRise/hb7.png";
import hb8 from "../assets/images/property/our service/highRise/hb8.png";
import hb9 from "../assets/images/property/our service/highRise/hb9.png";
import hb10 from "../assets/images/property/our service/highRise/hb10.png";
import rh1 from "../assets/images/property/our service/rowHouse/rh1.png";
import rh2 from "../assets/images/property/our service/rowHouse/rh2.png";
import rh3 from "../assets/images/property/our service/rowHouse/rh3.png";
import rh4 from "../assets/images/property/our service/rowHouse/rh4.png";

import fh1 from "../assets/images/property/our service/farmHouse/fh1.png";
import fh2 from "../assets/images/property/our service/farmHouse/fh2.png";
import fh3 from "../assets/images/property/our service/farmHouse/fh3.png";
import fh4 from "../assets/images/property/our service/farmHouse/fh4.png";

import bl1 from "../assets/images/property/our service/bunglows/bl1.png";
import bl2 from "../assets/images/property/our service/bunglows/bl2.png";
import bl3 from "../assets/images/property/our service/bunglows/bl3.png";
import bl4 from "../assets/images/property/our service/bunglows/bl4.png";

import dn1 from "../assets/images/property/our service/developed/dn1.png";
import dn2 from "../assets/images/property/our service/developed/dn2.png";
import dn3 from "../assets/images/property/our service/developed/dn3.png";
import dn4 from "../assets/images/property/our service/developed/dn4.png";
import dn5 from "../assets/images/property/our service/developed/dn5.png";
import dn6 from "../assets/images/property/our service/developed/dn6.png";
import dn7 from "../assets/images/property/our service/developed/dn7.png";
import dn8 from "../assets/images/property/our service/developed/dn8.png";
import g1 from "../assets/images/property/our service/gardens/g1.png";
import g2 from "../assets/images/property/our service/gardens/g2.png";
import g3 from "../assets/images/property/our service/gardens/g3.png";
import g4 from "../assets/images/property/our service/gardens/g4.png";

import pp1 from "../assets/images/property/our service/partyPlot/pp1.png";
import pp2 from "../assets/images/property/our service/partyPlot/pp2.png";
import pp3 from "../assets/images/property/our service/partyPlot/pp3.png";
import pp4 from "../assets/images/property/our service/partyPlot/pp4.png";

import gym1 from "../assets/images/property/our service/gym/gym1.png";
import gym2 from "../assets/images/property/our service/gym/gym2.png";
import gym3 from "../assets/images/property/our service/gym/gym3.png";
import gym4 from "../assets/images/property/our service/gym/gym4.png";

import sp1 from "../assets/images/property/our service/swimingPool/sp1.png";
import sp2 from "../assets/images/property/our service/swimingPool/sp2.png";
import sp3 from "../assets/images/property/our service/swimingPool/sp3.png";
import sp4 from "../assets/images/property/our service/swimingPool/sp4.png";

import pg1 from "../assets/images/property/our service/playArea/pg1.png";
import pg2 from "../assets/images/property/our service/playArea/pg2.png";
import pg3 from "../assets/images/property/our service/playArea/pg3.png";
import pg4 from "../assets/images/property/our service/playArea/pg4.png";

import r1 from "../assets/images/property/our service/realestate/r1.png";
import r2 from "../assets/images/property/our service/realestate/r2.png";
import r3 from "../assets/images/property/our service/realestate/r3.png";
import r4 from "../assets/images/property/our service/realestate/r4.png";

export const realestate = [
  {
    id: 1,
    image: r1,
  },
  {
    id: 2,
    image: r2,
  },
  {
    id: 3,
    image: r3,
  },
  {
    id: 4,
    image: r4,
  },
];

export const lowRiseBuilding = [
  {
    id: 1,
    image: lb1,
  },
  {
    id: 2,
    image: lb2,
  },
  {
    id: 3,
    image: lb3,
  },
  {
    id: 4,
    image: lb4,
  },
  // {
  //   id: 5,
  //   image: lb5,
  // },
  // {
  //   id: 6,
  //   image: lb6,
  // },
  // {
  //   id: 7,
  //   image: lb7,
  // },
  // {
  //   id: 8,
  //   image: lb8,
  // },
  // {
  //   id: 9,
  //   image: lb9,
  // },
  // {
  //   id: 10,
  //   image: lb10,
  // },
];
export const highRiseBuilding = [
  {
    id: 1,
    image: hb1,
  },
  {
    id: 2,
    image: hb2,
  },
  {
    id: 3,
    image: hb3,
  },
  {
    id: 4,
    image: hb4,
  },
  {
    id: 5,
    image: hb5,
  },
  {
    id: 6,
    image: hb6,
  },
  {
    id: 7,
    image: hb7,
  },
  {
    id: 8,
    image: hb8,
  },
  // {
  //   id: 9,
  //   image: hb9,
  // },
  // {
  //   id: 10,
  //   image: hb10,
  // },
];
export const rowHouse = [
  {
    id: 1,
    image: rh1,
  },
  {
    id: 2,
    image: rh2,
  },
  {
    id: 3,
    image: rh3,
  },
  {
    id: 4,
    image: rh4,
  },
  // {
  //   id: 5,
  //   image: rh5,
  // },
  // {
  //   id: 6,
  //   image: rh6,
  // },
  // {
  //   id: 7,
  //   image: rh7,
  // },
  // {
  //   id: 8,
  //   image: rh8,
  // },
  // {
  //   id: 9,
  //   image: rh9,
  // },
  // {
  //   id: 10,
  //   image: rh10,
  // },
];
export const farmHouse = [
  {
    id: 1,
    image: fh1,
  },
  {
    id: 2,
    image: fh2,
  },
  {
    id: 3,
    image: fh3,
  },
  {
    id: 4,
    image: fh4,
  },
  // {
  //   id: 5,
  //   image: fh5,
  // },
  // {
  //   id: 6,
  //   image: fh6,
  // },
  // {
  //   id: 7,
  //   image: fh7,
  // },
  // {
  //   id: 8,
  //   image: fh8,
  // },
];

export const bunglow = [
  {
    id: 1,
    image: bl1,
  },
  {
    id: 2,
    image: bl2,
  },
  {
    id: 3,
    image: bl3,
  },
  {
    id: 4,
    image: bl4,
  },
  // {
  //   id: 5,
  //   image: bl5,
  // },
  // {
  //   id: 6,
  //   image: bl6,
  // },
  // {
  //   id: 7,
  //   image: bl7,
  // },
  // {
  //   id: 8,
  //   image: bl8,
  // },
  // {
  //   id: 9,
  //   image: bl9,
  // },
  // {
  //   id: 10,
  //   image: bl10,
  // },
];
export const openPlotting = [
  {
    id: 1,
    image: dn1,
  },
  {
    id: 2,
    image: dn2,
  },
  {
    id: 3,
    image: dn3,
  },
  {
    id: 4,
    image: dn4,
  },
  {
    id: 5,
    image: dn5,
  },
  {
    id: 6,
    image: dn6,
  },
  {
    id: 7,
    image: dn7,
  },
  {
    id: 8,
    image: dn8,
  },
];

export const gardens = [
  {
    id: 1,
    image: g1,
  },
  {
    id: 2,
    image: g2,
  },
  {
    id: 3,
    image: g3,
  },
  {
    id: 4,
    image: g4,
  },
  // {
  //   id: 5,
  //   image: g5,
  // },
  // {
  //   id: 6,
  //   image: g6,
  // },
  // {
  //   id: 7,
  //   image: g7,
  // },
  // {
  //   id: 8,
  //   image: g8,
  // },
  // {
  //   id: 9,
  //   image: g9,
  // },
  // {
  //   id: 10,
  //   image: g10,
  // },
];
export const partyPlot = [
  {
    id: 1,
    image: pp1,
  },
  {
    id: 2,
    image: pp2,
  },
  {
    id: 3,
    image: pp3,
  },
  {
    id: 4,
    image: pp4,
  },
  // {
  //   id: 5,
  //   image: pp5,
  // },
  // {
  //   id: 6,
  //   image: pp6,
  // },
  // {
  //   id: 7,
  //   image: pp7,
  // },
  // {
  //   id: 8,
  //   image: pp8,
  // },
  // {
  //   id: 9,
  //   image: pp9,
  // },
  // {
  //   id: 10,
  //   image: pp10,
  // },
];
export const playArea = [
  {
    id: 1,
    image: pg1,
  },
  {
    id: 2,
    image: pg2,
  },
  {
    id: 3,
    image: pg3,
  },
  {
    id: 4,
    image: pg4,
  },
  // {
  //   id: 5,
  //   image: pg5,
  // },
  // {
  //   id: 6,
  //   image: pg6,
  // },
  // {
  //   id: 7,
  //   image: pg7,
  // },
  // {
  //   id: 8,
  //   image: pg8,
  // },
  // {
  //   id: 9,
  //   image: pg9,
  // },
  // {
  //   id: 10,
  //   image: pg10,
  // },
];
export const swimmingPool = [
  {
    id: 1,
    image: sp1,
  },
  {
    id: 2,
    image: sp2,
  },
  {
    id: 3,
    image: sp3,
  },
  {
    id: 4,
    image: sp4,
  },
  // {
  //   id: 5,
  //   image: sp5,
  // },
  // {
  //   id: 6,
  //   image: sp6,
  // },
  // {
  //   id: 7,
  //   image: sp7,
  // },
  // {
  //   id: 8,
  //   image: sp8,
  // },
  // {
  //   id: 9,
  //   image: sp9,
  // },
  // {
  //   id: 10,
  //   image: sp10,
  // },
];

export const gym = [
  {
    id: 1,
    image: gym1,
  },
  {
    id: 2,
    image: gym2,
  },
  {
    id: 3,
    image: gym3,
  },
  {
    id: 4,
    image: gym4,
  },
  // {
  //   id: 5,
  //   image: gym5,
  // },
  // {
  //   id: 6,
  //   image: gym6,
  // },
  // {
  //   id: 7,
  //   image: gym7,
  // },
  // {
  //   id: 8,
  //   image: gym8,
  // },
];
